import React from 'react';
import './App.css';
import Homescreen from "./Homescreen/Homescreen"


function App() {
  return (
    <div className="app">
      <Homescreen />
    </div>
  );
}

export default App;
